export default "__VITE_ASSET__e623f275__"